let unauthorizedHandler = null;

export const setUserUnauthorizedHandler = (handler) => {
  unauthorizedHandler = handler;
};

/**
 * Decode JWT payload without verifying the signature.
 * Used only to skip a round trip when exp is already in the past.
 */
export const isJwtExpired = (token) => {
  if (!token) return true;
  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) return true;
    const payload = JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload.exp) return false;
    return payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

export const fetchWithUserAuth = async (url, options = {}) => {
  const { token: tokenOverride, ...fetchOptions } = options;
  const token = tokenOverride || localStorage.getItem('userToken');

  const headers = {
    'Content-Type': 'application/json',
    ...fetchOptions.headers
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...fetchOptions,
    headers
  });

  if (response.status === 401) {
    unauthorizedHandler?.();
    let message = 'Unauthorized';
    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      // ignore empty body
    }
    const error = new Error(message);
    error.status = 401;
    throw error;
  }

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok) {
    const error = new Error(data.message || 'API request failed');
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};
